import Siema from '@progress-wad/siema-slider';

(() => {
  const sliders = Array.from(document.querySelectorAll('.js-mobile-slider'));

  sliders.forEach((slider, index) => {
    const container = document.querySelector(`.MobileSlider--${index + 1}`);

    // Clone slider
    const sliderClone = slider.cloneNode(true);
    container.appendChild(sliderClone);

    new Siema({
      selector: sliderClone,
      perPage: 1.2,
      onInit() {
        // Set initial active slide
        container.querySelectorAll('.col-6')[this.currentSlide].classList.add('is-active');
      },
      onChange() {
        // Change active slide
        container.querySelector('.is-active').classList.remove('is-active');
        container.querySelectorAll('.col-6')[Math.round(this.currentSlide)].classList.add('is-active');
      }
    });
  });
})();
